module.exports = __webpack_public_path__ + "img/camera.94c56f34.svg";